import React from 'react';
import DatePicker from 'react-date-picker';
import TimePicker from 'react-time-picker';
//import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';

import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'

import classes from './Input.module.css';

const input = ( props ) => {
    let inputElement = null;
    const inputClasses = [ classes.InputElement ];

    if( props.invalid && props.shouldValidate && props.touched ) {
        inputClasses.push( classes.Invalid );
    }

    switch( props.elementType ) {
        case ( 'input' ):
            inputElement = <input id={props.elementId} onChange={props.changed} className={inputClasses.join( ' ' )} {...props.elementConfig} value={props.value} />
            break;
        case ( 'textarea' ):
            inputElement = <textarea id={props.elementId} onChange={props.changed} className={inputClasses.join( ' ' )} {...props.elementConfig} value={props.value} />
            break;
        case ( 'select' ):
            inputElement = (
                <select id={props.elementId} onChange={props.changed} className={inputClasses.join( ' ' )} {...props.elementConfig} value={props.value}>
                    {props.elementConfig.options.map( option => (
                        <option key={option.value} value={option.value}>{option.displayValue}</option>
                    ) )}
                </select> )
            break;
        case ( 'date' ):
            inputElement = <DatePicker id={props.elementId} value={props.value} onChange={props.dateTimeChanged}  {...props.elementConfig} />
            break;
        case ( 'datetime' ):
            let dateTime = moment( props.value );
            inputElement = (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DateTimePicker onChange={props.dateTimeChanged} value={dateTime} format={'E MM/d h:mm a'} />
                </MuiPickersUtilsProvider>
            );
            break;
        case ( 'time' ):
            inputElement = <TimePicker id={props.elementId} value={props.value} onChange={props.dateTimeChanged}  {...props.elementConfig} />
            break;
        default:
            inputElement = <input id={props.elementId} onChange={props.changed} className={inputClasses.join( ' ' )} {...props.elementConfig} value={props.value} />
    }

    return (
        <div className={classes.Input}>
            <label className={classes.Label}>{props.label}
                {inputElement}
            </label>
        </div >
    );
};

export default input;